<template>
  <v-menu
    offset-y
    left
    nudge-bottom="14"
    min-width="286"
    content-class="user-profile-menu-content"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-badge
        bottom
        color="success"
        overlap
        offset-x="12"
        offset-y="12"
        class="ms-4"
        dot
      >
        <v-avatar
          size="40px"
          v-bind="attrs"
          color="primary"
          class="v-avatar-light-bg primary--text"
          v-on="on"
        >
          <v-img :src="require('@/assets/images/avatars/1.png')"></v-img>
        </v-avatar>
      </v-badge>
    </template>
    <v-list class="user-profile-menu">
      <div class="user-profile-menu__header">
        <div class="user-profile-menu__hero"></div>
        <rmr-action-button
          label="Logout"
          variant="utility"
          size="xs"
          :icon="icons.mdiLogoutVariant"
          :color="colors.danger"
          class="user-profile-menu__logout-icon"
          @click="logoutUser"
        />
        <div class="user-profile-menu__identity">
          <v-badge
            bottom
            color="success"
            overlap
            offset-x="12"
            offset-y="12"
            class="user-profile-menu__badge"
            dot
          >
            <v-avatar
              size="52px"
              color="primary"
              class="user-profile-menu__avatar"
            >
              <v-img :src="require('@/assets/images/avatars/1.png')"></v-img>
            </v-avatar>
          </v-badge>
          <div class="user-profile-menu__meta">
            <div class="user-profile-menu__name">
              {{ userName }}
            </div>
            <div v-if="userEmail" class="user-profile-menu__email">
              <v-icon size="14" class="user-profile-menu__meta-icon">
                {{ icons.mdiEmailOutline }}
              </v-icon>
              <span>{{ userEmail }}</span>
            </div>
          </div>
        </div>
      </div>
    </v-list>
  </v-menu>
</template>

<script>
import RmrActionButton from "@/components/ui/actions/RmrActionButton.vue";
import RmrKeywordChips from "@/components/ui/feedback/RmrKeywordChips.vue";
import {
  mdiEmailOutline,
  mdiLogoutVariant,
} from "@mdi/js";
import ability from "@/plugins/acl/ability";
import { initialAbility } from "@/plugins/acl/config";
import store from "@/store";
import { useRouter } from "@core/utils";
import { computed } from "@vue/composition-api";
import { RMR_DANGER } from "@/styles/tokens";

export default {
  components: { RmrActionButton, RmrKeywordChips },
  setup() {
    const { router } = useRouter();
    const userEmail = computed(() => {
      return localStorage.getItem("userEmail");
    });
    const userName = computed(() => {
      return localStorage.getItem("userName");
    });
    const userRoles = computed(() => {
      return JSON.parse(localStorage.getItem("userRoles") || "[]");
    });

    const logoutUser = () => {
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("userAbility");
      localStorage.removeItem("userName");
      localStorage.removeItem("userEmail");
      localStorage.removeItem("userRoles");
      ability.update(initialAbility);
      store.dispatch("app/setHomePageURL", "/");
      store.dispatch("app/setUserName", "");
      store.dispatch("app/setUserEmail", "");
      router.push({ name: "auth-login" });
    };
    return {
      logoutUser,
      userEmail,
      userName,
      userRoles,
      icons: {
        mdiEmailOutline,
        mdiLogoutVariant,
      },
      colors: {
        danger: RMR_DANGER,
      },
    };
  },
};
</script>

<style lang="scss">
.user-profile-menu-content {
  border-radius: $rmr-radius-2xl !important;
  border: 1px solid $rmr-border !important;
  box-shadow: $rmr-shadow-card !important;
  overflow: hidden;

  .v-list {
    padding: 0 !important;
  }

  .v-list-item {
    min-height: 2.5rem !important;
  }
}

.user-profile-menu {
  background: linear-gradient(180deg, $rmr-surface-0 0%, $rmr-surface-1 100%);
}

.user-profile-menu__header {
  position: relative;
  padding: 0 0 12px;
  border-bottom: 1px solid $rmr-border;
}

.user-profile-menu__hero {
  height: 56px;
  background:
    radial-gradient(circle at top right, rgba($rmr-indigo, 0.24), transparent 34%),
    linear-gradient(135deg, $rmr-surface-0 0%, $rmr-indigo-bg 72%, rgba($rmr-rpm, 0.08) 100%);
}

.user-profile-menu__logout-icon {
  position: absolute !important;
  top: 8px;
  right: 8px;
  z-index: 1;
  box-shadow: 0 6px 14px rgba($rmr-danger, 0.08);
}

.user-profile-menu__logout-icon::v-deep {
  min-width: 0 !important;
  height: 22px !important;
  padding: 0 8px !important;
}

.user-profile-menu__logout-icon::v-deep .v-btn__content {
  gap: 3px;
}

.user-profile-menu__logout-icon::v-deep .rmr-action-btn__icon {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.user-profile-menu__logout-icon::v-deep .rmr-action-btn__icon--size-xs {
  font-size: 11px !important;
}

.user-profile-menu__identity {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 0 16px;
  margin-top: -16px;
}

.user-profile-menu__badge {
  flex: 0 0 auto;
}

.user-profile-menu__avatar {
  background: linear-gradient(135deg, $rmr-indigo-bg 0%, rgba($rmr-rpm, 0.12) 100%) !important;
  border: 3px solid rgba($rmr-surface-0, 0.96);
  box-shadow:
    0 0 0 2px rgba($rmr-indigo, 0.22),
    0 8px 18px rgba($rmr-indigo, 0.16);
}

.user-profile-menu__meta {
  min-width: 0;
  flex: 1 1 auto;
  padding-top: 8px;
}

.user-profile-menu__name {
  color: $rmr-text-primary;
  font-size: 15px;
  font-weight: 800;
  line-height: 1.15;
  letter-spacing: -0.02em;
}

.user-profile-menu__email {
  display: flex;
  align-items: flex-start;
  gap: 5px;
  margin-top: 4px;
  color: $rmr-text-secondary;
  font-size: 11px;
  line-height: 1.3;
  overflow-wrap: anywhere;
}

.user-profile-menu__meta-icon {
  margin-top: 1px;
  color: $rmr-text-subtle !important;
}

.user-profile-menu__chips {
  margin-top: 8px;
}

.user-profile-menu__chips ::v-deep .rmr-keyword-chips {
  gap: 0;
}

.user-profile-menu__chips ::v-deep .rmr-keyword-chips__list {
  gap: 4px;
}

.user-profile-menu__chips ::v-deep .rmr-keyword-chips__chip {
  height: 20px !important;
  padding: 0 7px !important;
  font-size: 10px !important;
}

@media (max-width: 599px) {
  .user-profile-menu__name {
    font-size: 14px;
  }
}
</style>
